export default "__VITE_ASSET__CrPs9G$p__"